import "../styles/Siniestro.css";
import { Accordion } from "react-bootstrap";

const Siniestro = ({ siniestros, pasosSiniestros }) => {
  const tabs_perfil = (active) => {
    let items = document.querySelectorAll(".nav-perfil-links li.nav-item");
    let items_body = document.querySelectorAll(".tab-pane");

    if (active === "0") {
      items_body[0].classList.add("active");
      items_body[1].classList.remove("active");
      items_body[2].classList.remove("active");
      items_body[3].classList.remove("active");

      items[0].classList.add("item_activado");
      items[1].classList.remove("item_activado");
      items[2].classList.remove("item_activado");
      items[3].classList.remove("item_activado");
    } else if (active === "1") {
      items_body[0].classList.remove("active");
      items_body[1].classList.add("active");
      items_body[2].classList.remove("active");
      items_body[3].classList.remove("active");

      items[0].classList.remove("item_activado");
      items[1].classList.add("item_activado");
      items[2].classList.remove("item_activado");
      items[3].classList.remove("item_activado");
    } else if (active === "2") {
      items_body[0].classList.remove("active");
      items_body[1].classList.remove("active");
      items_body[2].classList.add("active");
      items_body[3].classList.remove("active");

      items[0].classList.remove("item_activado");
      items[1].classList.remove("item_activado");
      items[2].classList.add("item_activado");
      items[3].classList.remove("item_activado");
    } else if (active === "3") {
      items_body[0].classList.remove("active");
      items_body[1].classList.remove("active");
      items_body[2].classList.remove("active");
      items_body[3].classList.add("active");

      items[0].classList.remove("item_activado");
      items[1].classList.remove("item_activado");
      items[2].classList.remove("item_activado");
      items[3].classList.add("item_activado");
    }
  };

  return (
    <div className="container ps-0 pe-0">
      <div
        className="homeout__coberturas pt-lg-5 mt-lg-5"
        id="siniestro"
        style={{ paddingBottom: "0rem" }}
      >
        <h2 className="pe-3 ps-3">Reporta un siniestro</h2>
        <p className="pe-3 ps-3" style={{ fontSize: "1.5rem" }}>
          Reúne los documentos abajo listados y contáctanos vía{" "}
          <span
            style={{ color: "var(--rojo)", fontFamily: "var(--fuente-bold)" }}
          >
            <b>Whatsapp</b>
          </span>{" "}
          al{" "}
          <a
            href="https://wa.me/5662186906"
            target="_blank"
            rel="noreferrer"
            style={{ color: "var(--rojo)", fontFamily: "var(--fuente-bold)" }}
          >
            <b>56 6218 6906</b>
          </a>{" "}
          o comunícate al{" "}
          <a
            href="tel:8005220973"
            style={{ color: "var(--rojo)", fontFamily: "var(--fuente-bold)" }}
          >
            <b>800 522 0973</b>
          </a>{" "}
          de lunes a viernes de 08:00 a 21:00 hrs. Aquí te ayudaremos a
          continuar con tu proceso de reclamo de siniestro
        </p>

        {/* VERSION MOBILE */}
        <div className="pt-5 d-block d-md-block d-lg-none">
          <Accordion defaultActiveKey="0" flush>
            {siniestros &&
              siniestros.map((siniestro, index) => {
                let pasoFiltrados = pasosSiniestros.filter(
                  (ps) => ps.idTabSiniestro === siniestro.id
                );
                return (
                  <Accordion.Item eventKey={String(index)}>
                    <Accordion.Header className="accordion__header__siniestro">
                      <div className="header__accordion">
                        {siniestro.tituloTab}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div
                        style={{ marginBottom: "4rem" }}
                        className="texto__siniestro__div"
                      >
                        <p>
                          Para hacer efectivo el pago de la indemnización por
                          esta cobertura, deberás presentar los siguientes
                          documentos:
                        </p>
                        <br />
                        <ol className=" texto__siniestro list-group-numbered">
                          {pasoFiltrados.map((paso, indexPaso) => {
                            return (
                              <li className="list-group-item d-flex justify-content-between align-items-start">
                                <div
                                  className="ms-2 me-auto paso__siniestro"
                                  style={{ textAlign: "justify" }}
                                >
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: paso.descripcionPaso,
                                    }}
                                  ></p>
                                </div>
                              </li>
                            );
                          })}
                        </ol>
                        <p>
                          En casos extraordinarios si no nos es posible
                          demostrar la procedencia del Evento, solicitaremos más
                          información sobre los hechos relacionados con éste.
                        </p>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
          </Accordion>
        </div>

        {/* VERSION DESKTOP */}
        <div className="col-lg-7 d-none d-md-none d-lg-block body__siniestro">
          <div>
            <ul id="pr" className="nav nav-perfil-links">
              {siniestros &&
                siniestros.map((siniestro, index) => {
                  return (
                    <li
                      index={index}
                      className={
                        index === 0 ? "nav-item item_activado" : "nav-item"
                      }
                      style={{ cursor: "pointer" }}
                      onClick={() => tabs_perfil(`${index}`)}
                    >
                      <div
                        className="nav-link navSiniestro active"
                        data-toggle="tab"
                      >
                        {siniestro.tituloTab}
                      </div>
                    </li>
                  );
                })}
            </ul>
          </div>

          <div style={{ background: "var(--gris-claro)" }}>
            <div className="tab-content div-siniestro">
              {siniestros &&
                siniestros.map((siniestro, index) => {
                  let pasoFiltrados = pasosSiniestros.filter(
                    (ps) => ps.idTabSiniestro === siniestro.id
                  );
                  return (
                    <div
                      className={
                        index === 0
                          ? "tab-pane container texto__siniestro__div active"
                          : "tab-pane texto__siniestro__div container"
                      }
                    >
                      <p>
                        Para hacer efectivo el pago de la indemnización por esta
                        cobertura, deberás presentar los siguientes documentos:
                      </p>
                      <br />
                      <ol className=" texto__siniestro list-group-numbered">
                        {pasoFiltrados.map((paso, indexPaso) => {
                          return (
                            <li className="list-group-item d-flex justify-content-between align-items-start">
                              <div className="ms-2 me-auto paso__siniestro">
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: paso.descripcionPaso,
                                  }}
                                ></p>
                                <br />
                              </div>
                            </li>
                          );
                        })}
                      </ol>
                      <p>
                        En casos extraordinarios si no nos es posible demostrar
                        la procedencia del Evento, solicitaremos más información
                        sobre los hechos relacionados con éste.
                      </p>
                      <div className="pb-5"></div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Siniestro;
